// Source: https://usehooks-ts.com/react-hook/use-is-mounted.
import { useCallback, useEffect, useRef } from 'react';
/**
 * Custom hook to determine whether the component is currently mounted or not.
 */
function useIsMounted() {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return useCallback(() => isMounted.current, []);
}
export default useIsMounted;
